import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "export-img-dialog" }
const _hoisted_2 = { class: "thumbnails-view" }
const _hoisted_3 = {
  class: "thumbnails",
  ref: "imageThumbnailsRef"
}
const _hoisted_4 = { class: "configs" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = {
  key: 0,
  class: "row"
}
const _hoisted_8 = ["data-range"]
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "config-item" }
const _hoisted_12 = { class: "btns" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ThumbnailSlide = _resolveComponent("ThumbnailSlide")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_RadioGroup = _resolveComponent("RadioGroup")!
  const _component_Slider = _resolveComponent("Slider")!
  const _component_Switch = _resolveComponent("Switch")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_Button = _resolveComponent("Button")!
  const _component_FullscreenSpin = _resolveComponent("FullscreenSpin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.renderSlides, (slide) => {
          return (_openBlock(), _createBlock(_component_ThumbnailSlide, {
            class: "thumbnail",
            key: slide.id,
            slide: slide,
            size: 1600
          }, null, 8, ["slide"]))
        }), 128))
      ], 512)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "title" }, "导出格式：", -1)),
        _createVNode(_component_RadioGroup, {
          class: "config-item",
          value: _ctx.format,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.format) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_RadioButton, {
              style: {"width":"50%"},
              value: "jpeg"
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createTextVNode("JPEG")
              ])),
              _: 1
            }),
            _createVNode(_component_RadioButton, {
              style: {"width":"50%"},
              value: "png"
            }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [
                _createTextVNode("PNG")
              ])),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "title" }, "导出范围：", -1)),
        _createVNode(_component_RadioGroup, {
          class: "config-item",
          value: _ctx.rangeType,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.rangeType) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_RadioButton, {
              style: {"width":"33.33%"},
              value: "all"
            }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [
                _createTextVNode("全部")
              ])),
              _: 1
            }),
            _createVNode(_component_RadioButton, {
              style: {"width":"33.33%"},
              value: "current"
            }, {
              default: _withCtx(() => _cache[11] || (_cache[11] = [
                _createTextVNode("当前页")
              ])),
              _: 1
            }),
            _createVNode(_component_RadioButton, {
              style: {"width":"33.33%"},
              value: "custom"
            }, {
              default: _withCtx(() => _cache[12] || (_cache[12] = [
                _createTextVNode("自定义")
              ])),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      (_ctx.rangeType === 'custom')
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", {
              class: "title",
              "data-range": `（${_ctx.range[0]} ~ ${_ctx.range[1]}）`
            }, "自定义范围：", 8, _hoisted_8),
            _createVNode(_component_Slider, {
              class: "config-item",
              range: "",
              min: 1,
              max: _ctx.slides.length,
              step: 1,
              value: _ctx.range,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.range) = $event))
            }, null, 8, ["max", "value"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "title" }, "图片质量：", -1)),
        _createVNode(_component_Slider, {
          class: "config-item",
          min: 0,
          max: 1,
          step: 0.1,
          value: _ctx.quality,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.quality) = $event))
        }, null, 8, ["value"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "title" }, "忽略在线字体：", -1)),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_Tooltip, {
            mouseLeaveDelay: 0,
            mouseEnterDelay: 0.5,
            title: "导出时默认忽略在线字体，若您在幻灯片中使用了在线字体，且希望导出后保留相关样式，可选择关闭【忽略在线字体】选项，但要注意这将会增加导出用时。"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Switch, {
                checked: _ctx.ignoreWebfont,
                "onUpdate:checked": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.ignoreWebfont) = $event))
              }, null, 8, ["checked"])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_Button, {
        class: "btn export",
        type: "primary",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.expImage()))
      }, {
        default: _withCtx(() => _cache[16] || (_cache[16] = [
          _createTextVNode("导出图片")
        ])),
        _: 1
      }),
      _createVNode(_component_Button, {
        class: "btn close",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.close()))
      }, {
        default: _withCtx(() => _cache[17] || (_cache[17] = [
          _createTextVNode("关闭")
        ])),
        _: 1
      })
    ]),
    _createVNode(_component_FullscreenSpin, {
      loading: _ctx.exporting,
      tip: "正在导出..."
    }, null, 8, ["loading"])
  ]))
}